export default __webpack_public_path__ + "static/media/youtubeDarkTheme.bc467ee0.svg";